import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../../firebase";
import { Navbar } from "../../../../Components/Navbar/Navbar";
import { Footer } from "../../../../Components/Footer/footer";
import "./style.css";

interface PressRelease {
  id: string;
  title: string;
  content: string;
  date: string;
  image_url?: string;
}

export function ComunicatPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const [release, setRelease] = useState<PressRelease | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      const docRef = doc(db, "site_content", "press_page");
      const snap = await getDoc(docRef);
      if (snap.exists()) {
        const data = snap.data();
        const match = (data.press_releases || []).find(
          (item: PressRelease) => item.id === id
        );
        setRelease(match || null);
      }
    };
    fetchData();
  }, [id]);

  if (!release) {
    return (
      <div className="page-container">
        <Navbar />
        <div className="page-content">
          <h1>Comunicatul nu a fost găsit</h1>
          <button onClick={() => navigate(-1)}>Înapoi</button>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="page-container">
      <Navbar />
      <div className="page-content">
        <button className="back-button" onClick={() => navigate(-1)}>
          ← Înapoi
        </button>

        {release.image_url && (
          <img
            src={release.image_url}
            alt="Imagine comunicat"
            className="press-banner-img"
          />
        )}

        <h1>{release.title}</h1>
        <p className="press-date">
          {new Date(release.date).toLocaleDateString("ro-RO", {
            day: "numeric",
            month: "long",
            year: "numeric",
          })}
        </p>

        <div className="press-content">{release.content}</div>
      </div>
      <Footer />
    </div>
  );
}
